// Import packages
import React, { Component } from "react";
import { connect } from "react-redux";
import {Switch, Tree} from "antd";

//import styles
import '../../assets/styles/containerStyles/appended-product-section.scss';

// Import components
import PageWrapper from '../../components/pageContentViews/pageWrapper'
import MediaSelectorModal from "../../components/media/MediaSelectorModal";
import { InputGroup } from "../../components/uiElements/inputGroup";
import { LinkButton } from "../../components/buttons/buttons";
import { MediaFileCard } from "../../components/media/MediaFileCard";

// Import utils
import {
    arraysEquals,
    changeStateField,
    getInputValues, getPatchReqData, getPostReqData,
    getTranslatableInputValues, getTranslationsInitialValues,
    initTranslations, toggleStateField,
} from "../../utils/helperFunctions";
import { mapStateToProps } from "../../redux/mapStateToProps";
import {
    CreateArticle,
    GetArticleById,
    UpdateArticleById,
} from "../../redux/actions";
import { validateTranslations } from "../../utils/validateTranslations";
import { ACCEPT_IMAGE_TYPES } from "../../constants/acceptedTypes";
import { history } from "../../configs/history";
import {LanguageTabs} from "../../components/uiElements/Tabs";
import {MAIN_LANGUAGE_TYPES} from "../../constants/constsTypes";
import {transformImage} from "../../utils/transformImage";
import {Editor} from "../../components/uiElements/Editor";


class AddEditArticle extends Component {
    constructor (props) {
        super(props);
        this.translationsFields = [
            'title',
            'description',
        ];
        this.state = {
            fieldsData: {
                translations: initTranslations(this.translationsFields),
                image:null,
                cover:null,
                is_hidden: false,
                categories:[],
            },
            errors: {},
            errorsTabs: [],
            isEditing: !!props?.id,
            languageTab: MAIN_LANGUAGE_TYPES.en,
            requestLoading: false,
            mediaModalType: '',
        };
        this.updatedDataMap = new Map();
        this.currentData = null;
        this.toggleMediaModal = toggleStateField.bind(this, 'mediaModalOpen');
        this.toggleCoverModal = toggleStateField.bind(this, 'coverModalOpen');
        this.changeLanguageTab = changeStateField.bind(this, 'languageTab');
        this.getInputValues = getInputValues.bind(this);
        this.getTranslatableInputValues = getTranslatableInputValues.bind(this);
        this.getPatchReqData = getPatchReqData.bind(this);
        this.getPostReqData = getPostReqData.bind(this);
        this.addEditArticle = this.addEditArticle.bind(this);
    }

    async componentDidMount () {
        const { isEditing} = this.state;

        if (isEditing) {
            await this.props.GetArticleById(this.props.id);
            const editingData = this.props.articleById
            if (editingData) {
                const initStateData = {
                    translations: getTranslationsInitialValues(editingData.translations, ['title','description']),
                    image: editingData?.image_object_name ?
                        transformImage(editingData.image_object_name, editingData.image_url )
                        : null,
                    cover: editingData?.cover_object_name ?
                        transformImage(editingData.cover_object_name, editingData.cover_url )
                        : null,
                    web_cover: editingData?.web_cover_object_name ?
                        transformImage(editingData.web_cover_object_name, editingData.web_cover_url )
                        : null,
                    is_hidden: editingData?.is_hidden,
                    categories: editingData?.categories.map(item => {return item?.id}) || [],
                }
                this.currentData = JSON.parse(JSON.stringify(initStateData));
                this.setState({
                    fieldsData: initStateData,
                });
            }
        }
    }

    getMedia(type, mediaArray) {
        const {fieldsData, errors} = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: mediaArray[0],
            },
            errors: {
                ...errors,
                [type]: false
            }
        })
    }

    deleteMedia(type) {
        const {fieldsData,} = this.state;
        this.setState({
            fieldsData: {
                ...fieldsData,
                [type]: null,
            }
        })
    }

    toggleMediaModalType(type = '') {
        this.setState({
            mediaModalType: type
        })
    }

    async addEditArticle () {
        await this.setState({
            requestLoading: true
        });
        const { translations, image,} = this.state.fieldsData;
        const translationRequiredFields = ['title', 'description']
        const validationTr = validateTranslations(translations, translationRequiredFields)
        let result = validationTr.result;
        const errors = { ...validationTr.errors };

        if (!image) {
            errors.image = true;
            result = false;
        }
        if (result) {
            if (!this.state.isEditing) {
                let reqData = this.getPostReqData(this.state.fieldsData);
                this.props.CreateArticle(reqData).finally(() => {
                    this.setState({ requestLoading: false });
                })
            } else {
                // const trData = getTranslationData(translations);
                // const reqData = this.getPatchReqData(trData);
                let reqData = this.getPostReqData(this.state.fieldsData);
                if (Object.keys(reqData).length) {
                    this.props.UpdateArticleById(this.props.id, reqData)
                        .finally(() => {
                            this.setState({ requestLoading: false });
                            history.push('/article')
                        });
                }

            }
        } else {
            this.setState({
                requestLoading: false,
                errors: errors,
                errorsTabs: validationTr.errorsTabs
            })
        }
    }

    getMultiSelectData = (checkedKeys, name) => {
        const { fieldsData, isEditing } = this.state;
        if (isEditing) {
            const updatedValues = checkedKeys?.length ? checkedKeys : []
            arraysEquals(this.currentData?.[name], checkedKeys)
                ? this.updatedDataMap.delete(name)
                : this.updatedDataMap.set(name, updatedValues);
        }
        this.setState({
            fieldsData: {
                ...fieldsData,
                [name]: checkedKeys,
            }
        })
    };

    treeData = (data, children) => {
        const treeData = [];
        data.forEach(item => {
            const treeItem = {
                title: item.title,
                key: item.id,
            };
            if (item[children] && item[children]?.length) {
                treeItem.children = this.treeData(item[children], children)
            }
            treeData.push(treeItem);
        })
        return treeData;
    };


    render () {
        const {
            fieldsData,
            errors,
            languageTab,
            isEditing,
            errorsTabs,
            requestLoading,
            mediaModalType
        } = this.state;
        const {categoriesList} = this.props
        const initData = this.currentData?.translations?.find(item => item?.lang === languageTab) || {};
        const currentData = fieldsData.translations?.find(item => item?.lang === languageTab) || {};
        return <PageWrapper pageTitle={!isEditing ? 'Ավելացնել Բլոգ' : 'Փոփոխել Բլոգ'}>
            <section className="general-add-edit">
                <div className="fixed-top-right">
                    <label>{!fieldsData.is_hidden ? "Ակտիվ " : "Ոչ ակտիվ "}</label>
                    <Switch checked={!fieldsData.is_hidden}
                            onChange={(checked) => this.getInputValues({
                                name: "is_hidden",
                                value: !checked,
                                haveChanges: this.currentData?.is_hidden !== !checked
                            })}/>
                </div>

                <div className="top-side">
                    <label>Cover image <span className={'required-badge'}>*</span></label>
                    <LinkButton title="Ընտրել մեդիադարանից"
                                className={`media-select-btn ${errors.image ? 'media-select-error' : ''}`}
                                cb={this.toggleMediaModalType.bind(this, 'image')}
                    />
                </div>
                {fieldsData?.image && <div className={'main-media'}>
                    <MediaFileCard item={fieldsData?.image}
                    />
                </div>}
                <div className="top-side">
                    <label>Mobile image</label>
                    <LinkButton title="Ընտրել մեդիադարանից"
                                className={`media-select-btn`}
                                cb={this.toggleMediaModalType.bind(this, 'cover')}
                    />
                </div>
                {fieldsData?.cover && <div className={'main-media'}>
                    <MediaFileCard item={fieldsData?.cover}
                                   customDelete={this.deleteMedia.bind(this, 'cover')}
                    />
                </div>}
                <div className="top-side">
                    <label>Web image</label>
                    <LinkButton title="Ընտրել մեդիադարանից"
                                className={`media-select-btn`}
                                cb={this.toggleMediaModalType.bind(this, 'web_cover')}
                    />
                </div>
                {fieldsData?.web_cover && <div className={'main-media'}>
                    <MediaFileCard item={fieldsData?.web_cover}
                                   customDelete={this.deleteMedia.bind(this, 'web_cover')}
                    />
                </div>}
                <LanguageTabs changeLanguageTab={this.changeLanguageTab}
                              errorsTabs={errorsTabs}
                              activeTab={languageTab}/>

                <InputGroup inputType="input"
                            type="text"
                            label="Անվանում"
                            placeholder="Անվանում"
                            name="title"
                            required={true}
                            value={currentData.title}
                            initValue={initData.title}
                            error={errors['title' + languageTab]}
                            maxLength={100}
                            onChange={this.getTranslatableInputValues}/>
                <div className={'editors'}>
                    <div className={'editor-wrapper'}>
                        <label>Նկարագրություն <span className={'required-badge'}>*</span></label>
                        <Editor
                            value={currentData.description || ""}
                            name={'description'}
                            initValue={fieldsData?.description}
                            error={errors['description' + languageTab]}
                            disableToolbar={true}
                            onChange={this.getTranslatableInputValues}/>
                    </div>
                </div>

                <div className="tree-item">
                    <label>Կատեգորիաներ</label>
                    <Tree
                        checkable
                        checkedKeys={fieldsData.categories}
                        onCheck={(keys) => this.getMultiSelectData(keys, 'categories')}
                        showLine={true}
                        treeData={this.treeData(categoriesList, "values")}
                    />
                </div>

                <div className="flex-wrapper-right">
                    <LinkButton title={!isEditing ? 'Ավելացնել' : 'Փոփոխել'}
                        loading={requestLoading}
                                cb={this.addEditArticle}/>
                </div>
            </section>
            <MediaSelectorModal
                isOpen={!!mediaModalType}
                acceptTypes={ACCEPT_IMAGE_TYPES}
                getMedia={this.getMedia.bind(this, mediaModalType)}
                closeModal={this.toggleMediaModalType.bind(this)}
            />
        </PageWrapper>
    }
}

const mapDispatchToProps = {
    CreateArticle,
    GetArticleById,
    UpdateArticleById,
};

export default connect(mapStateToProps, mapDispatchToProps)(AddEditArticle)
